import styled from "styled-components";

export const ResultTitle = styled.h2`
  text-align: center;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Tries = styled.h5`
  @media (max-width: 768px) {
    text-align: center;
    width: 100%;
  }

  margin-top: 0;
`;

export const SongTitle = styled.h3`
  text-align: center;
  @media (max-width: 768px) {
    text-align: center;
    width: 100%;
  }

  margin-top: 0;
`;

export const TimeToNext = styled.h4`
  @media (max-width: 768px) {
    text-align: center;
    width: 100%;
  }
`;
